import React from "react";
import { withWorkOrderLogic, WithWorkOrderLogicProps, TableDescription, TableRemark, TableCalculation, CalculationDataType } from "../../components/hoc_work_order";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, Checkbox, Modal, TabsProps, Tabs, Select, TimePicker, Space, Tooltip, InputNumber, DatePicker, notification, Spin } from "antd";
import "./work_order.css";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import ModulBillingForWo from "./modal_billing_for_wo";
import ModalChassisForWo from "./modal_chassis_for_wo";
import ModalAddEditForWo from "./modal_add_edit_for_wo";
import { BiRefresh, BiSolidEditAlt } from "react-icons/bi";
import { RiFileCloseFill } from "react-icons/ri";
import axios from "axios";
import { MdAddToPhotos, MdDeleteForever } from "react-icons/md";


const WorkOrder: React.FC<WithWorkOrderLogicProps> = ({
    descriptionDataSource,
    descriptionRowSelection,
    handleDescriptionDelete,
    handleDescriptionAdd,
    handleDescriptionSave,
    remarkDataSource,
    remarkRowSelection,
    handleRemarkDelete,
    handleRemarkAdd,
    handleRemarkSave,
    isModalOpen,
    showModal,
    handleOk,
    handleCancel,
    isChassisModalOpen,
    showChassisModal,
    handleChassisOk,
    handleChassisCancel,
    form,
    handleChassisSelect,
    handleBillingSelect,
    calculationDataSource,
    calculationColumns,
    calculationRowSelection,
    handleCalculationDelete,
    isAddEditModalOpen,
    handleCalculationAddRow,
    showAddEditModal,
    handleAddEditOk,
    handleAddEditCancel,
    isCurrentUserDetailsVisible,
    toggleCurrentUserDetails,
    isVehicleDetailsVisible,
    toggleVehicleDetails,
    isStnkDetailsVisible,
    toggleStnkDetails,
    isBillingDetailsVisible,
    toggleBillingDetails,
    isCalculationVisible,
    toggleCalculation,
    addEditForm,
    handleCalculationSubmit,
    handleCalculationEdit,
    editingRecord,
    brands,
    models,
    warehouses,
    autosaveStatus,
    handleFormChange,
    handleSubmitWorkOrder,
    handleVoidWorkOrder,
    handleCloseOrder,
    handlePrintWorkOrder,
    isPrinting,
    serviceAdvisorName,
    handleNew,
    handleReviseWorkOrder,
    isReportModalOpen,
    handleReportModalCancel,
    handleRefreshCalculations,
    lockedFields,
    onFieldFocus,
    onFieldBlur,
    onFormValuesChange
}) => {
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Revisebtn = BiSolidEditAlt as React.ComponentType<any>;
    const Closebtn = RiFileCloseFill as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const isBillToCodeFilled = !!form.getFieldValue('bill_to_code');
    const isChassisNoFilled = !!form.getFieldValue('chassis_no');
    const isStatusDraft = form.getFieldValue('status') === 'Draft' || form.getFieldValue('status') === '1' || form.getFieldValue('status') === 'Billing Preparation' || form.getFieldValue('status') === '9';
    const isStatusNew = form.getFieldValue('status') === 'New';
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Customer Detail',
            children: (
                <>
                    <div className="gjs-grid-row" id="izdfi">
                        <div className="gjs-grid-column" id="iytqd">
                            <Form
                                form={form}
                                preserve={true}
                                layout="horizontal"
                                style={{ maxWidth: 500 }}
                                onValuesChange={onFormValuesChange}
                                labelCol={{ style: { width: '180px', textAlign: "left" } }}
                                wrapperCol={{ style: { width: '290px' } }}
                                className="custom-info-purchase-request"
                            >
                                <Form.Item
                                    label="Status"
                                    name="status"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["status"] ? `Sedang diedit oleh ${lockedFields["status"].userName}` : undefined}
                                    validateStatus={lockedFields?.["status"] ? "warning" : undefined}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item name="service_advisor" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Service Advisor"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input value={serviceAdvisorName} placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Work Estimation No"
                                    name="work_estimation_no"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["work_estimation_no"] ? `Sedang diedit oleh ${lockedFields["work_estimation_no"].userName}` : undefined}
                                    validateStatus={lockedFields?.["work_estimation_no"] ? "warning" : undefined}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Work Estimation Date"
                                    name="work_estimation_date"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Work Order No"
                                    name="work_order_no"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Work Order Date"
                                    name="work_order_date"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Brand"
                                    name="brand"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["brand"] ? `Sedang diedit oleh ${lockedFields["brand"].userName}` : undefined}
                                    validateStatus={lockedFields?.["brand"] ? "warning" : undefined}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={brands}
                                        disabled={!!lockedFields?.["brand"]}
                                        onDropdownVisibleChange={(open) => open ? onFieldFocus("brand") : onFieldBlur("brand")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Model"
                                    name="model"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["model"] ? `Sedang diedit oleh ${lockedFields["model"].userName}` : undefined}
                                    validateStatus={lockedFields?.["model"] ? "warning" : undefined}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={models}
                                        disabled={!!lockedFields?.["model"]}
                                        onDropdownVisibleChange={(open) => open ? onFieldFocus("model") : onFieldBlur("model")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Service Site"
                                    name="service_site"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["service_site"] ? `Sedang diedit oleh ${lockedFields["service_site"].userName}` : undefined}
                                    validateStatus={lockedFields?.["service_site"] ? "warning" : undefined}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={[
                                            { label: "Bay Reguler", value: "RG" },
                                            { label: "Service Car", value: "SC" },
                                            { label: "Service On Site", value: "OS" },
                                        ]}
                                        disabled={!!lockedFields?.["service_site"]}
                                        onDropdownVisibleChange={(open) => open ? onFieldFocus("service_site") : onFieldBlur("service_site")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Warehouse"
                                    name="warehouse"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["warehouse"] ? `Sedang diedit oleh ${lockedFields["warehouse"].userName}` : undefined}
                                    validateStatus={lockedFields?.["warehouse"] ? "warning" : undefined}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={warehouses}
                                        disabled={!!lockedFields?.["warehouse"]}
                                        onDropdownVisibleChange={(open) => open ? onFieldFocus("warehouse") : onFieldBlur("warehouse")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Chassis No"
                                    style={{ marginBottom: "5px" }}
                                    help={lockedFields?.["chassis_no"] ? `Sedang diedit oleh ${lockedFields["chassis_no"].userName}` : undefined}
                                    validateStatus={lockedFields?.["chassis_no"] ? "warning" : undefined}
                                >
                                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <Form.Item
                                            name="chassis_no"
                                            noStyle
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'Chassis No. wajib diisi.' }]}
                                        >
                                            <Input
                                                style={{ width: "100%" }}
                                                readOnly
                                            />
                                        </Form.Item>
                                        <Button
                                            type="primary"
                                            id="modal_chassis_for_wo"
                                            onClick={showChassisModal}
                                            disabled={isChassisNoFilled || !!lockedFields?.["chassis_no"]}
                                            icon={
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                    <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                    <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                    <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                </svg>}
                                        />
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    label="No Polisi"
                                    name="no_polisi"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["no_polisi"] ? `Sedang diedit oleh ${lockedFields["no_polisi"].userName}` : undefined}
                                    validateStatus={lockedFields?.["no_polisi"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["no_polisi"]}
                                        onFocus={() => onFieldFocus("no_polisi")}
                                        onBlur={() => onFieldBlur("no_polisi")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Bill To"
                                    style={{ marginBottom: "5px" }}
                                    help={lockedFields?.["bill_to_code"] ? `Sedang diedit oleh ${lockedFields["bill_to_code"].userName}` : undefined}
                                    validateStatus={lockedFields?.["bill_to_code"] ? "warning" : undefined}
                                >
                                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <Form.Item
                                            name="bill_to_code"
                                            noStyle
                                            style={{ width: "100%" }}>
                                            <Input
                                                style={{ width: "100%" }}
                                                readOnly
                                            />
                                        </Form.Item>
                                        <Button
                                            type="primary"
                                            id="modal_billing_for_wo"
                                            onClick={showModal}
                                            disabled={isBillToCodeFilled || !!lockedFields?.["bill_to_code"]}
                                            icon={
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                    <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                    <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                    <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                </svg>}
                                        />
                                        <Form.Item
                                            name="bill_to_name"
                                            noStyle
                                            style={{ width: "100%" }}>
                                            <Input
                                                style={{ width: "100%" }}
                                                readOnly
                                            />
                                        </Form.Item>
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    label="Arrival Time"
                                    name="arrival_time"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["arrival_time"] ? `Sedang diedit oleh ${lockedFields["arrival_time"].userName}` : undefined}
                                    validateStatus={lockedFields?.["arrival_time"] ? "warning" : undefined}
                                >
                                    <TimePicker
                                        format="HH:mm"
                                        style={{ width: '45%' }}
                                        disabled={!!lockedFields?.["arrival_time"]}
                                        onOpenChange={(open) => open ? onFieldFocus("arrival_time") : onFieldBlur("arrival_time")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Current Milage"
                                    name="current_milage"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["current_milage"] ? `Sedang diedit oleh ${lockedFields["current_milage"].userName}` : undefined}
                                    validateStatus={lockedFields?.["current_milage"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["current_milage"]}
                                        onFocus={() => onFieldFocus("current_milage")}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            form.setFieldsValue({ last_miliage_detail: val });
                                            handleFormChange({ current_milage: val, last_miliage_detail: val }, { ...form.getFieldsValue(), last_miliage_detail: val });
                                        }}
                                        onBlur={async (e) => {
                                            onFieldBlur("current_milage");
                                            const currentMilage = e.target.value;
                                            const chassisNo = form.getFieldValue('chassis_no');
                                            if (chassisNo && currentMilage) {
                                                try {
                                                    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/work-order/update-milage`, {
                                                        chassis_no: chassisNo,
                                                        current_milage: parseInt(currentMilage, 10)
                                                    });
                                                    notification.success({
                                                        message: 'Update Milage',
                                                        description: 'Last KM kendaraan berhasil diperbarui.',
                                                        placement: 'topRight',
                                                    });
                                                } catch (error) {
                                                    console.error("Failed to update vehicle milage:", error);
                                                    notification.error({
                                                        message: 'Update Milage Gagal',
                                                        description: 'Gagal memperbarui Last KM kendaraan.',
                                                        placement: 'topRight',
                                                    });
                                                }
                                            }
                                        }} />
                                </Form.Item>
                                <Form.Item
                                    label="Current Message"
                                    name="current_message"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["current_message"] ? `Sedang diedit oleh ${lockedFields["current_message"].userName}` : undefined}
                                    validateStatus={lockedFields?.["current_message"] ? "warning" : undefined}
                                >
                                    <Input.TextArea
                                        rows={2}
                                        placeholder=""
                                        disabled={!!lockedFields?.["current_message"]}
                                        onFocus={() => onFieldFocus("current_message")}
                                        onBlur={() => onFieldBlur("current_message")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Remark Outstanding"
                                    name="remark_outstanding"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["remark_outstanding"] ? `Sedang diedit oleh ${lockedFields["remark_outstanding"].userName}` : undefined}
                                    validateStatus={lockedFields?.["remark_outstanding"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["remark_outstanding"]}
                                        onFocus={() => onFieldFocus("remark_outstanding")}
                                        onBlur={() => onFieldBlur("remark_outstanding")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Reason"
                                    name="reason"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["reason"] ? `Sedang diedit oleh ${lockedFields["reason"].userName}` : undefined}
                                    validateStatus={lockedFields?.["reason"] ? "warning" : undefined}
                                >
                                    <Input.TextArea
                                        rows={4}
                                        placeholder=""
                                        disabled={!!lockedFields?.["reason"]}
                                        onFocus={() => onFieldFocus("reason")}
                                        onBlur={() => onFieldBlur("reason")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Approval Remark"
                                    name="approval_remark"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input.TextArea rows={4} placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label={<span style={{ fontWeight: "600" }}>Contact Person</span>}
                                    style={{
                                        marginBottom: "0px",
                                        paddingTop: "20px"
                                    }}>
                                    <div
                                        style={{
                                            gap: "0px",
                                            marginTop: "0px",
                                        }}>
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    label="Name"
                                    name="name_contact"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["name_contact"] ? `Sedang diedit oleh ${lockedFields["name_contact"].userName}` : undefined}
                                    validateStatus={lockedFields?.["name_contact"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["name_contact"]}
                                        onFocus={() => onFieldFocus("name_contact")}
                                        onBlur={() => onFieldBlur("name_contact")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Phone"
                                    name="phone_contact"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[{ required: true, message: 'Wajib diisi' }]}
                                    help={lockedFields?.["phone_contact"] ? `Sedang diedit oleh ${lockedFields["phone_contact"].userName}` : undefined}
                                    validateStatus={lockedFields?.["phone_contact"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["phone_contact"]}
                                        onFocus={() => onFieldFocus("phone_contact")}
                                        onBlur={() => onFieldBlur("phone_contact")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={<span style={{ fontWeight: "600" }}>Insurance</span>}
                                    style={{
                                        marginBottom: "0px",
                                        paddingTop: "20px"
                                    }}>
                                    <div
                                        style={{
                                            gap: "0px",
                                            marginTop: "0px",
                                        }}>
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    label="Policy"
                                    name="policy"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["policy"] ? `Sedang diedit oleh ${lockedFields["policy"].userName}` : undefined}
                                    validateStatus={lockedFields?.["policy"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["policy"]}
                                        onFocus={() => onFieldFocus("policy")}
                                        onBlur={() => onFieldBlur("policy")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Expired Date"
                                    name="expired_date"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["expired_date"] ? `Sedang diedit oleh ${lockedFields["expired_date"].userName}` : undefined}
                                    validateStatus={lockedFields?.["expired_date"] ? "warning" : undefined}
                                >
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        style={{ width: '50%' }}
                                        disabled={!!lockedFields?.["expired_date"]}
                                        onOpenChange={(open) => open ? onFieldFocus("expired_date") : onFieldBlur("expired_date")}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Claim No"
                                    name="claim_no"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    help={lockedFields?.["claim_no"] ? `Sedang diedit oleh ${lockedFields["claim_no"].userName}` : undefined}
                                    validateStatus={lockedFields?.["claim_no"] ? "warning" : undefined}
                                >
                                    <Input
                                        placeholder=""
                                        disabled={!!lockedFields?.["claim_no"]}
                                        onFocus={() => onFieldFocus("claim_no")}
                                        onBlur={() => onFieldBlur("claim_no")}
                                    />
                                </Form.Item>
                            </Form>
                            <div style={{ marginTop: '20px' }}>
                                <h3 style={{ marginBottom: '16px' }}>Request Description</h3>
                                <TableDescription
                                    dataSource={descriptionDataSource}
                                    rowSelection={descriptionRowSelection}
                                    handleDelete={handleDescriptionDelete}
                                    handleAdd={handleDescriptionAdd}
                                    handleSave={handleDescriptionSave}
                                />
                            </div>
                            <div style={{ marginTop: '40px' }}>
                                <h3 style={{ marginBottom: '16px' }}>Vehicle Remark</h3>
                                <TableRemark
                                    dataSource={remarkDataSource}
                                    rowSelection={remarkRowSelection}
                                    handleDelete={handleRemarkDelete}
                                    handleAdd={handleRemarkAdd}
                                    handleSave={handleRemarkSave}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="gjs-grid-row" id="it9ts">
                        <div className="gjs-grid-column" id="ic88n">
                            <Form
                                form={form}
                                layout="horizontal"
                                style={{ maxWidth: 500 }}
                                onValuesChange={onFormValuesChange}
                                labelCol={{ style: { width: '180px', textAlign: "left" } }}
                                wrapperCol={{ style: { width: '290px' } }}
                                className="custom-info-purchase-request"
                            >
                                <div className="grid-2" style={{ paddingTop: "50px" }}>
                                    <Form.Item
                                        label={<span style={{ fontWeight: "600" }}>Current User Details</span>}
                                        style={{
                                            marginBottom: "0px",
                                            paddingBottom: "10px",
                                        }}>
                                        <div
                                            style={{
                                                gap: "0px",
                                                marginTop: "0px",
                                            }}>

                                            <Checkbox checked={isCurrentUserDetailsVisible} onChange={toggleCurrentUserDetails} style={{ fontWeight: 600 }}>
                                                Show
                                            </Checkbox>
                                        </div>
                                    </Form.Item>

                                    {isCurrentUserDetailsVisible && (
                                        <>
                                            <Form.Item
                                                label="Name"
                                                name="name_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["name_detail"] ? `Sedang diedit oleh ${lockedFields["name_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["name_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["name_detail"]}
                                                    onFocus={() => onFieldFocus("name_detail")}
                                                    onBlur={() => onFieldBlur("name_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="No ID"
                                                name="no_id_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["no_id_detail"] ? `Sedang diedit oleh ${lockedFields["no_id_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["no_id_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["no_id_detail"]}
                                                    onFocus={() => onFieldFocus("no_id_detail")}
                                                    onBlur={() => onFieldBlur("no_id_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Address"
                                                name="address_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["address_detail"] ? `Sedang diedit oleh ${lockedFields["address_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["address_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["address_detail"]}
                                                    onFocus={() => onFieldFocus("address_detail")}
                                                    onBlur={() => onFieldBlur("address_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Provinsi"
                                                name="provinsi_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["provinsi_detail"] ? `Sedang diedit oleh ${lockedFields["provinsi_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["provinsi_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["provinsi_detail"]}
                                                    onFocus={() => onFieldFocus("provinsi_detail")}
                                                    onBlur={() => onFieldBlur("provinsi_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kabupaten"
                                                name="kabupaten_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kabupaten_detail"] ? `Sedang diedit oleh ${lockedFields["kabupaten_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kabupaten_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kabupaten_detail"]}
                                                    onFocus={() => onFieldFocus("kabupaten_detail")}
                                                    onBlur={() => onFieldBlur("kabupaten_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kecamatan"
                                                name="kecamatan_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kecamatan_detail"] ? `Sedang diedit oleh ${lockedFields["kecamatan_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kecamatan_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kecamatan_detail"]}
                                                    onFocus={() => onFieldFocus("kecamatan_detail")}
                                                    onBlur={() => onFieldBlur("kecamatan_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kelurahan"
                                                name="kelurahan_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kelurahan_detail"] ? `Sedang diedit oleh ${lockedFields["kelurahan_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kelurahan_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kelurahan_detail"]}
                                                    onFocus={() => onFieldFocus("kelurahan_detail")}
                                                    onBlur={() => onFieldBlur("kelurahan_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kode Pos"
                                                name="kode_pos_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kode_pos_detail"] ? `Sedang diedit oleh ${lockedFields["kode_pos_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kode_pos_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kode_pos_detail"]}
                                                    onFocus={() => onFieldFocus("kode_pos_detail")}
                                                    onBlur={() => onFieldBlur("kode_pos_detail")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Phone Number"
                                                name="phone_number_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["phone_number_detail"] ? `Sedang diedit oleh ${lockedFields["phone_number_detail"].userName}` : undefined}
                                                validateStatus={lockedFields?.["phone_number_detail"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["phone_number_detail"]}
                                                    onFocus={() => onFieldFocus("phone_number_detail")}
                                                    onBlur={() => onFieldBlur("phone_number_detail")}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                    <div className="grid-2" style={{ paddingTop: "50px" }}>
                                        <Form.Item
                                            label={<span style={{ fontWeight: "600" }}>STNK Details</span>}
                                            style={{
                                                marginBottom: "0px",
                                                paddingBottom: "10px",
                                            }}>
                                            <div
                                                style={{
                                                    gap: "0px",
                                                    marginTop: "0px",
                                                }}>

                                                <Checkbox checked={isStnkDetailsVisible} onChange={toggleStnkDetails} style={{ fontWeight: 600 }}>
                                                    Show
                                                </Checkbox>
                                            </div>
                                        </Form.Item>

                                        {isStnkDetailsVisible && (
                                            <>
                                                <Form.Item
                                                    label="STNK Name"
                                                    name="stnk_name"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="STNK Address"
                                                    name="stnk_address"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Provinsi"
                                                    name="provinsi_stnk"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Kabupaten"
                                                    name="kabupaten_stnk"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Kecamatan"
                                                    name="kecamatan_stnk"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Kelurahan"
                                                    name="kelurahan_stnk"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Kode Pos"
                                                    name="kode_pos_stnk"
                                                    style={{
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Input placeholder="" />
                                                </Form.Item>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Form>
                        </div>
                        <div className="gjs-grid-column" id="itec1">
                            <div className="grid-2" style={{ paddingTop: "50px" }}>
                                <Form
                                    form={form}
                                    layout="horizontal"
                                    style={{ maxWidth: 500 }}
                                    onValuesChange={onFormValuesChange}
                                    labelCol={{ style: { width: '180px', textAlign: "left" } }}
                                    wrapperCol={{ style: { width: '290px' } }}
                                    className="custom-info-purchase-request"
                                >
                                    <Form.Item
                                        label={<span style={{ fontWeight: "600" }}>Vehicle Details</span>}
                                        style={{
                                            marginBottom: "0px",
                                            paddingBottom: "10px",
                                        }}>
                                        <div
                                            style={{
                                                gap: "0px",
                                                marginTop: "0px",
                                            }}>

                                            <Checkbox checked={isVehicleDetailsVisible} onChange={toggleVehicleDetails} style={{ fontWeight: 600 }}>
                                                Show
                                            </Checkbox>
                                        </div>
                                    </Form.Item>

                                    {isVehicleDetailsVisible && (
                                        <>
                                            <Form.Item
                                                label="Engine No."
                                                name="engine_no_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <Input placeholder="" />
                                            </Form.Item>
                                            <Form.Item
                                                label="Brand"
                                                name="brand_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <Input placeholder="" />
                                            </Form.Item>
                                            <Form.Item
                                                label="Model"
                                                name="model_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <Input placeholder="" />
                                            </Form.Item>
                                            <Form.Item
                                                label="Last Service"
                                                name="last_service_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <Input placeholder="" />
                                            </Form.Item>
                                            <Form.Item
                                                label="Last Miliage"
                                                name="last_miliage_detail"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <Input placeholder="" />
                                            </Form.Item>
                                        </>
                                    )}
                                </Form>
                            </div>
                            <div className="grid-2" style={{ paddingTop: "50px" }}>
                                <Form
                                    form={form}
                                    layout="horizontal"
                                    style={{ maxWidth: 500 }}
                                    onValuesChange={handleFormChange}
                                    labelCol={{ style: { width: '180px', textAlign: "left" } }}
                                    wrapperCol={{ style: { width: '290px' } }}
                                    className="custom-info-purchase-request"
                                >
                                    <Form.Item
                                        label={<span style={{ fontWeight: "600" }}>Billing Details</span>}
                                        style={{
                                            marginBottom: "0px",
                                            paddingBottom: "10px",
                                        }}>
                                        <div
                                            style={{
                                                gap: "0px",
                                                marginTop: "0px",
                                            }}>

                                            <Checkbox checked={isBillingDetailsVisible} onChange={toggleBillingDetails} style={{ fontWeight: 600 }}>
                                                Show
                                            </Checkbox>
                                        </div>
                                    </Form.Item>

                                    {isBillingDetailsVisible && (
                                        <>
                                            <Button type="primary" id="change_billing" onClick={showModal}>
                                                <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                                                Change Billing
                                            </Button>
                                            <Form.Item
                                                label="Name"
                                                name="name_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["name_billing"] ? `Sedang diedit oleh ${lockedFields["name_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["name_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["name_billing"]}
                                                    onFocus={() => onFieldFocus("name_billing")}
                                                    onBlur={() => onFieldBlur("name_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Address"
                                                name="address_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["address_billing"] ? `Sedang diedit oleh ${lockedFields["address_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["address_billing"] ? "warning" : undefined}
                                            >
                                                <Input.TextArea
                                                    rows={4}
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["address_billing"]}
                                                    onFocus={() => onFieldFocus("address_billing")}
                                                    onBlur={() => onFieldBlur("address_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Provinsi"
                                                name="provinsi_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["provinsi_billing"] ? `Sedang diedit oleh ${lockedFields["provinsi_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["provinsi_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["provinsi_billing"]}
                                                    onFocus={() => onFieldFocus("provinsi_billing")}
                                                    onBlur={() => onFieldBlur("provinsi_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kabupaten"
                                                name="kabupaten_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kabupaten_billing"] ? `Sedang diedit oleh ${lockedFields["kabupaten_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kabupaten_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kabupaten_billing"]}
                                                    onFocus={() => onFieldFocus("kabupaten_billing")}
                                                    onBlur={() => onFieldBlur("kabupaten_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kecamatan"
                                                name="kecamatan_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kecamatan_billing"] ? `Sedang diedit oleh ${lockedFields["kecamatan_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kecamatan_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kecamatan_billing"]}
                                                    onFocus={() => onFieldFocus("kecamatan_billing")}
                                                    onBlur={() => onFieldBlur("kecamatan_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kelurahan"
                                                name="kelurahan_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kelurahan_billing"] ? `Sedang diedit oleh ${lockedFields["kelurahan_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kelurahan_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kelurahan_billing"]}
                                                    onFocus={() => onFieldFocus("kelurahan_billing")}
                                                    onBlur={() => onFieldBlur("kelurahan_billing")}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Kode Pos"
                                                name="kode_pos_billing"
                                                style={{
                                                    marginBottom: "5px",
                                                }}
                                                help={lockedFields?.["kode_pos_billing"] ? `Sedang diedit oleh ${lockedFields["kode_pos_billing"].userName}` : undefined}
                                                validateStatus={lockedFields?.["kode_pos_billing"] ? "warning" : undefined}
                                            >
                                                <Input
                                                    placeholder=""
                                                    disabled={!!lockedFields?.["kode_pos_billing"]}
                                                    onFocus={() => onFieldFocus("kode_pos_billing")}
                                                    onBlur={() => onFieldBlur("kode_pos_billing")}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </>
            ),
        },
        {
            key: '2',
            label: 'Spareparts Detail',
            children: (
                <Form
                    form={form}
                    preserve={true}
                    layout="horizontal"
                    style={{ maxWidth: 500, paddingTop: "20px" }}
                    onValuesChange={onFormValuesChange}
                    labelCol={{ style: { width: '180px', textAlign: "left" } }}
                    wrapperCol={{ style: { width: '290px' } }}
                    className="custom-info-purchase-request"
                >
                    <Form.Item
                        label="Estimated Duration"
                        name="estimated_duration"
                        style={{
                            marginBottom: "5px",
                        }}
                        help={lockedFields?.["estimated_duration"] ? `Sedang diedit oleh ${lockedFields["estimated_duration"].userName}` : undefined}
                        validateStatus={lockedFields?.["estimated_duration"] ? "warning" : undefined}
                    >
                        <TimePicker
                            format="HH:mm"
                            style={{ width: '45%' }}
                            disabled={!!lockedFields?.["estimated_duration"]}
                            onOpenChange={(open) => open ? onFieldFocus("estimated_duration") : onFieldBlur("estimated_duration")}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Notes"
                        name="notes"
                        style={{
                            marginBottom: "5px",
                        }}
                        help={lockedFields?.["notes"] ? `Sedang diedit oleh ${lockedFields["notes"].userName}` : undefined}
                        validateStatus={lockedFields?.["notes"] ? "warning" : undefined}
                    >
                        <Input.TextArea
                            rows={4}
                            placeholder=""
                            disabled={!!lockedFields?.["notes"]}
                            onFocus={() => onFieldFocus("notes")}
                            onBlur={() => onFieldBlur("notes")}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Recommendation"
                        name="recommendation"
                        style={{
                            marginBottom: "5px",
                        }}
                        help={lockedFields?.["recommendation"] ? `Sedang diedit oleh ${lockedFields["recommendation"].userName}` : undefined}
                        validateStatus={lockedFields?.["recommendation"] ? "warning" : undefined}
                    >
                        <Input.TextArea
                            rows={4}
                            placeholder=""
                            disabled={!!lockedFields?.["recommendation"]}
                            onFocus={() => onFieldFocus("recommendation")}
                            onBlur={() => onFieldBlur("recommendation")}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Down Payment"
                        name="down_payment"
                        style={{
                            marginBottom: "5px",
                        }}
                        help={lockedFields?.["down_payment"] ? `Sedang diedit oleh ${lockedFields["down_payment"].userName}` : undefined}
                        validateStatus={lockedFields?.["down_payment"] ? "warning" : undefined}
                    >
                        <InputNumber
                            style={{ width: "100%" }}
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                            parser={(value) => value!.replace(/\./g, '')}
                            placeholder=""
                            disabled={!!lockedFields?.["down_payment"]}
                            onFocus={() => onFieldFocus("down_payment")}
                            onBlur={() => onFieldBlur("down_payment")}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Credit Limit Remaining"
                        name="credit_limit_remaining"
                        style={{
                            marginBottom: "5px",
                        }}
                        help={lockedFields?.["credit_limit_remaining"] ? `Sedang diedit oleh ${lockedFields["credit_limit_remaining"].userName}` : undefined}
                        validateStatus={lockedFields?.["credit_limit_remaining"] ? "warning" : undefined}
                    >
                        <InputNumber
                            style={{ width: "100%" }}
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                            parser={(value) => value!.replace(/\./g, '')}
                            placeholder=""
                            disabled={!!lockedFields?.["credit_limit_remaining"]}
                            onFocus={() => onFieldFocus("credit_limit_remaining")}
                            onBlur={() => onFieldBlur("credit_limit_remaining")}
                        />
                    </Form.Item>
                    <div className="grid-2" style={{ paddingTop: "50px" }}>
                        <Form.Item
                            label={<span style={{ fontWeight: "600" }}>Calculation</span>}
                            style={{
                                marginBottom: "0px",
                                paddingBottom: "10px",
                            }}>
                            <div
                                style={{
                                    gap: "0px",
                                    marginTop: "0px",
                                }}>

                                <Checkbox checked={isCalculationVisible} onChange={toggleCalculation} style={{ fontWeight: 600 }}>
                                    Show
                                </Checkbox>
                            </div>
                        </Form.Item>

                        {isCalculationVisible && (
                            <>
                                <Form.Item
                                    label="Sub Total"
                                    name="sub_total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        precision={2}
                                        style={{ width: "100%" }}
                                        formatter={(value) => `${value}`.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '').replace(/,/g, '.')}
                                        placeholder=""
                                        readOnly
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Discount"
                                    name="discount"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        precision={2}
                                        style={{ width: "100%" }}
                                        formatter={(value) => `${value}`.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '').replace(/,/g, '.')}
                                        placeholder=""
                                        readOnly
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Total"
                                    name="total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        precision={2}
                                        style={{ width: "100%" }}
                                        formatter={(value) => `${value}`.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '').replace(/,/g, '.')}
                                        placeholder=""
                                        readOnly
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Vat"
                                    name="vat"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        precision={2}
                                        style={{ width: "100%" }}
                                        formatter={(value) => `${value}`.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '').replace(/,/g, '.')}
                                        placeholder=""
                                        readOnly
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Grand Total"
                                    name="grand_total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        precision={2}
                                        style={{ width: "100%" }}
                                        formatter={(value) => `${value}`.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '').replace(/,/g, '.')}
                                        placeholder=""
                                        readOnly
                                    />
                                </Form.Item>
                            </>
                        )}
                    </div>
                    <div className="gjs-grid-row" id="xsad3e">
                        <div className="gjs-grid-column" id="hda73h">
                            <div style={{ marginTop: '16px', display: 'flex', gap: '8px' }}>
                                <Button className="gr-button" onClick={showAddEditModal}>
                                    <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                                    Add Line
                                </Button>
                                <Button className="gr-button" onClick={handleCalculationAddRow} >
                                    <MdAddToPhotos style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                                    Add Row
                                </Button>
                                <Button className="gr-button" onClick={handleCalculationDelete} disabled={autosaveStatus === 'processing' || ((calculationRowSelection?.selectedRowKeys || []) as React.Key[]).some((k) => !!lockedFields?.[`row_${k}`])}>
                                    <MdDeleteForever style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                                    Delete
                                </Button>
                                <Button className="gr-button" onClick={handleRefreshCalculations}>
                                    <BiRefresh style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                                    Refresh
                                </Button>
                            </div>
                            <TableCalculation
                                dataSource={calculationDataSource}
                                columns={calculationColumns}
                                rowSelection={calculationRowSelection}
                                lockedFields={lockedFields}
                                onRow={(record: CalculationDataType) => ({
                                    onDoubleClick: () => {
                                        handleCalculationEdit(record);
                                    },
                                })}
                            />

                        </div>
                    </div>
                </Form>

            ),
        },
    ];

    return (
        <Spin spinning={isPrinting} size="large" tip="Mempersiapkan Dokumen, Harap Tunggu...">
            <div id="isyy" style={transformStyle}>
                <div className="gjs-grid-row" id="ih9v">
                    <div className="gjs-grid-column" id="iy73">
                        <Breadcrumb
                            items={[
                                {
                                    title: <HomeOutlined />,
                                },
                                {
                                    href: "#/dashboard/data_work_order",
                                    title: (
                                        <>
                                            <span>Data Work Order</span>
                                        </>
                                    ),
                                },
                                {
                                    title: "Work Order",
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="gjs-grid-row" id="sdhjd3">
                    <div className="gjs-grid-column" id="saddjsj3">
                        <Button className="gr-button" onClick={handleNew}>
                            <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            New
                        </Button>
                        <Button className="gr-button" onClick={handleSubmitWorkOrder} disabled={!isStatusDraft || autosaveStatus === 'processing'}>
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                        <Button className="gr-button" onClick={handleVoidWorkOrder} disabled={!isStatusDraft || autosaveStatus === 'processing'}>
                            <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Void
                        </Button>
                        <Button className="gr-button" onClick={handleReviseWorkOrder} disabled={(form.getFieldValue('status') !== 'QC Pass' && form.getFieldValue('status') !== '6') || autosaveStatus === 'processing'}>
                            <Revisebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Revise
                        </Button>
                        <Button className="gr-button" onClick={handleCloseOrder} disabled={!isStatusNew || autosaveStatus === 'processing'}>
                            <Closebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Close Order
                        </Button>
                        <Button className="gr-button" onClick={handlePrintWorkOrder} loading={isPrinting} disabled={autosaveStatus === 'processing'}>
                            <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Print
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave Stopped">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>
                <Tabs defaultActiveKey="1" items={items} />
                <Modal
                    title="Select Billing Customer"
                    className="modal-billing-customer"
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    width='1200px'
                    footer={null}
                >
                    <ModulBillingForWo onBillingSelect={handleBillingSelect} />
                </Modal>
                <Modal
                    title="Select Chassis"
                    className="modal-chassis-customer"
                    open={isChassisModalOpen}
                    onOk={handleChassisOk}
                    onCancel={handleChassisCancel}
                    width='1200px'
                    footer={null}
                >
                    <ModalChassisForWo onChassisSelect={(record) => {
                        form.setFieldsValue({
                            brand: record.brandCode,
                            model: record.modelCode,
                        });
                        handleChassisSelect(record);
                    }} />
                </Modal>
                <Modal
                    className="modal-edit-add"
                    title="Add/Edit Calculation"
                    open={isAddEditModalOpen}
                    onOk={handleAddEditOk}
                    onCancel={handleAddEditCancel}
                    width='500px'
                    footer={null}
                >
                    <ModalAddEditForWo
                        form={addEditForm}
                        onFinish={handleCalculationSubmit}
                        onCancel={handleAddEditCancel}
                        isEditing={!!editingRecord}
                        existingItemCodes={calculationDataSource.filter(item => !editingRecord || item.key !== editingRecord.key).map(item => item.number)}
                    />
                </Modal>
                <Modal
                    title="Print Preview - Work Order"
                    open={isReportModalOpen}
                    onCancel={handleReportModalCancel}
                    footer={null}
                    width={1100}
                    destroyOnClose
                >
                    <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} />
                </Modal>
            </div >
        </Spin>
    );
};

export default withWorkOrderLogic(WorkOrder);